import { compact } from 'lodash/fp'

export const QueryKeys = {
  learnpaths: {
    uploadsAsset: (assetType?, assetId?) =>
      compact(['learnpaths', 'uploads', assetType, assetId]),
    assigned: (learnpathId?: string) =>
      compact(['learnpaths', 'assigned', learnpathId]),
    assignedElements: (learnpathId: string) => [
      ...QueryKeys.learnpaths.assigned(learnpathId),
      'elements',
    ],
    assignedElement: (learnpathId: string, elementId?: string) =>
      compact([
        ...QueryKeys.learnpaths.assignedElements(learnpathId),
        elementId,
      ]),
  },
  users: {
    groups: () => ['users', 'groups'],
    search: (query: string) => ['users', 'search', query],
  },
  glossary: {
    list: () => ['glossary'],
  },
  scorm: {
    state: (packageId: string) => ['scorm', 'state', packageId],
  },
  events: {
    all: ['events'],
    lists: () => [...QueryKeys.events.all, 'list'],
    list: (query: Record<string, any> = {}) => [
      ...QueryKeys.events.lists(),
      query,
    ],
    details: () => [...QueryKeys.events.all, 'detail'],
    detail: (eventId: string) => [...QueryKeys.events.details(), eventId],
    attendees: (eventId: string) => [
      ...QueryKeys.events.detail(eventId),
      'attendees',
    ],
  },
  extended: {
    youtubeVideo: (videoId: string) => ['youtube_video', videoId],
  },
}
